
    export default {
        name: 'JobCardBadge',

        props: {
            jobId: {
                type: Number,
                default: 0,
            },

            badge: {
                type: String,
                default: null,
            },

            badgeSize: {
                type: String,
                default: 'small',
            },
        },

        data() {
            return {};
        },

        methods: {
            getBadgeUrl(badge, size) {
                return require('@/assets/img/badges/' + badge.toLowerCase() + '_' + size + '.png');
            },

            getToolTipMessage(badge) {
                const badgeIcon = badge.toLowerCase();
                let toolTipMessage = '';

                switch (badgeIcon) {
                    case 'apsco':
                        toolTipMessage = 'This advertiser is an active Member with the Association of Professional Staffing Companies Australia (APSCo). This badge of quality gives job seekers the assurance of compliance and best practice throughout the recruitment process.';
                        break;
                    default:
                }

                return toolTipMessage;
            },
        },
    };
